<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent label-position="left">
            <el-form-item label="代理商：">
                <el-select v-model="searchForm.agentId" @change="getPkgSoldListPageHandle" filterable>
                    <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name+'（'+item.sysUserAccountName+'）'"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分配状态：">
                <el-select v-model="searchForm.state">
                    <el-option value="1" label="已分配"></el-option>
                    <el-option value="0" label="未分配"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属类别：">
                <el-select v-model="searchForm.supplierType" clearable>
                    <el-option v-for="item in supplierOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐组名称：">
                <el-select v-model="searchForm.pkgGroupId" clearable filterable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐名称：">
                <el-input  v-model="searchForm.packageName" clearable></el-input>
            </el-form-item>

            <el-form-item >
                <el-button type="primary" @click="getPkgSoldListPageHandle">搜索查询</el-button>
                <el-button type="primary" @click="batchAddSoldPkg()">批量分销</el-button>
                <el-button type="primary" @click="aKeyDistribution = true">一键分销</el-button>
            </el-form-item>



        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="pkgGroupName" label="套餐组名称"></el-table-column>
            <el-table-column prop="packageName" label="套餐名称"></el-table-column>
            <el-table-column prop="packageTypeName" label="套餐类型"></el-table-column>
            <el-table-column prop="supplierTypeName" label="所属类别" sortable></el-table-column>
            <el-table-column prop="verifyPriceRmb" label="套餐成本价（元）"></el-table-column>
            <el-table-column prop="salePriceRmb" label="套餐金额（元）"></el-table-column>            
            <el-table-column label="分销比例">
                <template slot-scope="scope">                    
                    <el-input v-if="scope.row.soldState==1" type="number" v-model="scope.row.soldPercent" :value="scope.row.soldPercent" @change="updateSoldPercentHandle(scope.row)"></el-input>
                    <span v-else>{{ scope.row.soldPercent }}</span>
                </template>                 
            </el-table-column>
             <el-table-column label="分销价格（元">
                <template slot-scope="scope">                    
                    <el-input v-if="scope.row.soldState==1" type="number" v-model="scope.row.soldPriceRmb" :value="scope.row.soldPriceRmb" @change="updateSoldPercentHandle1(scope.row)"></el-input>
                    <span v-else>{{ scope.row.soldPriceRmb }}</span>
                </template>                 
            </el-table-column>
            <el-table-column prop="soldStateName" label="状态" sortable></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="pkgDistributHandle(scope.row)">{{showbtnText(scope.row.soldState)}}</el-button>
                </template>                  
            </el-table-column>
        </el-table>
                  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  

        <!-- 一键分销 -->
        <el-dialog title="提示" :visible.sync="aKeyDistribution" :append-to-body="true" width="600px">
            <el-form :model="searchForm">
                <el-form-item label="套餐组名称：" :label-width="formLabelWidth">
                    <el-select v-model="searchForm.pkgGroupId" clearable filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span style="color:red;">此操作会将套餐组下面所有的套餐 分销给自己下级代理商,请确保代理商的分销比列正确，避免导致分销失败。</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="aKeyDistribution = false">取 消</el-button>
                <el-button type="primary" @click="aKeyDistribute">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getPkgSoldListPage, pkgDistribut, pkgDistributCancel, updateSoldPercent,updateSoldPercent1} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                pkgGroupId: '',
                agentId: '',
                state: '',
                supplierType: '',
                packageName: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },    
            pkgGroup: [],        
            agentListOption: [],
            supplierOption: [],
            title: '',

            aKeyDistribution: false, //一键分销
            formLabelWidth: '120px' //一键分销内嵌表单项的宽
        }
    },
    methods: {
        showbtnText(state){
            return common.showTxtByState(state, {0: '分销', 1: '移除'})
        },        
        getPkgSoldListPageHandle($event){
            // if(this.searchForm.agentId === ''){
            //     this.$message.error("请先选择代理商");
            //     return;               
            // }

            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getPkgSoldListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        pkgDistributHandle(row){
            var data = {
                packageId: row.packageId,
                agentId: this.searchForm.agentId
            }
            if(row.soldState == 1){
                data.nextId = row.nextId;
                pkgDistributCancel(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getPkgSoldListPageHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }else{
                pkgDistribut(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getPkgSoldListPageHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
        },
        updateSoldPercentHandle(row){            
            var data = {
                id: row.id,
                nextId: row.nextId,
                soldPercent: row.soldPercent
            }
            updateSoldPercent(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);                    
                }else{
                    this.$message.error(res.data.message);
                }
                this.getPkgSoldListPageHandle();
            })

        }, 
        updateSoldPercentHandle1(row){            
            var data = {
                id: row.id,
                nextId: row.nextId,
                soldPercent: row.soldPercent,
                pkgPrice:row.soldPriceRmb
            }
            updateSoldPercent1(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);                    
                }else{
                    this.$message.error(res.data.message);
                }
                this.getPkgSoldListPageHandle();
            })

        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgSoldListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getPkgSoldListPageHandle();
        },

        batchAddSoldPkg(){
            let data = {
                agentId: this.searchForm.agentId,
                pkgGroupIds: [this.searchForm.pkgGroupId],
            };

            common.sysRequest('pkg/sold/batchAddSoldPkg', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);                    
                }else{
                    this.$message.error(res.data.message);
                }
                this.getPkgSoldListPageHandle();
            });
        },
        
        //一键分销点击确定触发
        aKeyDistribute(){
            let data = {
                basePkgGroup: this.searchForm.pkgGroupId
            }
            if(this.searchForm.pkgGroupId){
                common.sysRequest('pkg/oneButton/sold/pkg', data, 'post').then(res => {
                    if(res.data.code == 200){
                        this.aKeyDistribution = false;
                        this.$message('正在分销中，请稍后查看分销信息');
                    }
                })
            }
            
        }
    },
    created(){
        common.getAgentListOptionCom(this, 'agentListOption');
        common.getSupplierOptionCom(this, 'supplierOption');
        common.getPkgGroupListCom(this, 'pkgGroup');
        // this.getPkgSoldListPageHandle();
    }
}
</script>
<style lang="less">

</style>

